import cssVars from 'css-vars-ponyfill';

function addLight(color, amount) {
    const cc = parseInt(color,16) + amount;
    const c = (cc > 255) ? 255 : (cc);
    return (c.toString(16).length > 1 ) ? c.toString(16) : `0${c.toString(16)}`;
}
  
function lighten(color, amount) {
    const transformedColor = (color.indexOf('#') >= 0) ? color.substring(1,color.length) : color;
    const transformedAmount = parseInt((255 * amount) / 100, 10);
    return `#${addLight(transformedColor.substring(0,2), transformedAmount)}${addLight(transformedColor.substring(2,4), transformedAmount)}${addLight(transformedColor.substring(4,6), transformedAmount)}`;
}

class ColorApplication {
    constructor({ primary, secondary }) {
        this.primary = primary;
        this.secondary = secondary;
        this.generateColors();
        this.generateHoverColors();
        cssVars()
    }

    generateColors() {
        document.documentElement.style.setProperty('--primary', this.primary);
        document.documentElement.style.setProperty('--secondary', this.secondary);
    }

    generateHoverColors() {
        document.documentElement.style.setProperty('--primary-hover', lighten(this.primary, 15));
        document.documentElement.style.setProperty('--secondary-hover', lighten(this.secondary, 15));
    }
}

window.ColorApplication = ColorApplication;